import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import CmpLogoutBtn from "../../components/logout-btn.cmp";
import CmpVideoInfo from "../../components/videoInfo.cmp";
import CmpVideoList from "../../components/videoList.cmp";
import CmpVideoPlayer from "../../components/videoPlayer.cmp";
import useLogin from "../../hooks/useLogin.hk";
import { getAllVideos, getVideos } from "../../service";
import { videoPlay } from "../../store/features/VideoSlice";
import { setPageTitle } from "../../utils/page";
import { googleAnalyticsTracker }  from "../../utils/google";
import "./videos.pg.scss";
import { timeToSeconds } from "../../utils/date";

const PgVideos = () => {
	const history = useHistory();
    const [user, , logout] = useLogin();
    const [state, setState] = useState({
		pageTitle: "",
        videos: [],
		expired: false
    });

	const dispatch = useDispatch();

	// Mini player flottante quando il player esce dalla vista (stile YouTube)
	const playerSlot = useRef();
	const currVideo = useSelector(state => state.video.currVideo);
	const started = useSelector(state => state.video.currentTime !== null);
	const [slotVisible, setSlotVisible] = useState(true);
	const [miniClosed, setMiniClosed] = useState(false);
	const floating = started && !slotVisible && !miniClosed;

	useEffect(() => {
		if (!playerSlot.current) return;
		const observer = new IntersectionObserver(([entry]) => {
			setSlotVisible(entry.isIntersecting);
			if (entry.isIntersecting) setMiniClosed(false);
		});
		observer.observe(playerSlot.current);
		return () => observer.disconnect();
	}, [state.videos.length]);

	const scrollToPlayer = () =>
		playerSlot.current?.scrollIntoView({ behavior: "smooth", block: "center" });

	// Cambio video mentre il player è fuori vista: torna al player
	useEffect(() => {
		if (!slotVisible) scrollToPlayer();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currVideo?.videoId]);

	useEffect(() => {
		setPageTitle("Video");
	});
    
    useEffect(() => {
        if (!user) { history.push("/login"); }
		else {
			googleAnalyticsTracker("page", "videos", user.username);

			getAllVideos(user.token, 10).then(res => {
				if (res.data.status === "OK") {
					const v = res.data.videos;

					for(let i = 0; i < res.data.videos.length; i++) {
						let video = res.data.videos[i];
						video["fromIa"] = false;
						if(video["idIa"].trim() !== "" && video["descriptionIa"].trim() !== "") {
							video["toc"] = [];
							try{
								video["toc"] = JSON.parse(video["descriptionIa"]).data.chapters;
								let html = `<h2>Indice dei Contenuti</h2>`

								for(let i = 0; i < video["toc"].length; i++) {
									let chapter = video["toc"][i];
									let chapterIdx = i + 1;
									html += `<article>
										<header>
											<h3><a class="chapter-link" title="${escapeAttr(`Capitolo ${chapterIdx}: ${chapter.title} (${chapter.sections[0].start})`)}" href="/video?id=${video["idIa"]}&t=${timeToSeconds(chapter.sections[0].start) === 0 ? 1 : timeToSeconds(chapter.sections[0].start) }">Capitolo ${chapterIdx}: ${chapter.title}</a></h3>
											<p><small>Durata capitolo: ${video["toc"][i].sections[0].start} - ${video["toc"][i].sections[video["toc"][i].sections.length -1].end}</small></p>
										</header>
										`;
									for(let j = 0; j < video["toc"][i].sections.length; j++) {
										let section = video["toc"][i].sections[j];
										let sectionIdx = j + 1;
										html += `<section><h4><a title="${escapeAttr(`${chapterIdx}.${sectionIdx} ${section.title} (${section.start} - ${section.end})`)}" href="/video?id=${video["idIa"]}&t=${timeToSeconds(section.start) === 0 ? 1 : timeToSeconds(section.start) }">
										${chapterIdx}.${sectionIdx} 
										${section.title} <span class="time-badge">(${section.start})</span></a></h4></section>`;
									}
									html += `</article>`
								}
								html += ``
								video["descriptionIa"] = html;
								video["fromIa"] = true;
							}catch(e) {
								video["toc"] = [];
								video["descriptionIa"] = "";
								video["fromIa"] = false;
							}
							
						}

					}

					
					setState({
						videos: v,
						pageTitle: res.data.pageTitle
					});
					googleAnalyticsTracker("page", "videos", user.username);

					if (v.length < 1) return;
					dispatch(videoPlay({video:v[0]}));
				}
				else {
					logout();
				}
			})
			.catch(err => logout());
		}
    }, [user]);

	const handleVideoLinkClick = ({ href, id, timestamp }) => {
		console.log("Video ID:", id); // "9eaa6233-8414-4c62-b552-273fa1a1a539"
		console.log("Seek Timestamp:", timestamp); // "100"

		let v = state.videos.filter(x => x.idIa == id)
		if(v.length == 1) {
			let video = v[0];
			dispatch(videoPlay({video:video, startTime: timestamp, t: new Date().getTime()}));
			let targetElement = document.querySelector(".video-player");
			if(targetElement) {
				targetElement.scrollIntoView({
					behavior: 'smooth', // 'auto' for instant jump
					block: 'start',     // 'start', 'center', 'end', or 'nearest'
					inline: 'nearest'
				});
			}
		}
			// if (timestamp) {
		// // Example: Seek current video player to 100 seconds
		// playerRef.current?.seekTo(Number(timestamp));
		// } else {
		// // Example: Navigate using React Router
		// navigate(href);
		// }
	};
    
	const hasSidebar = state.videos.length > 1;

    return (
        <div className = "pg-videos">
			<div className = "video-player">
				<div className = "container">
					<div className = "title-wrapper">
						{renderTitleDangerously(state.pageTitle)}

						{renderBtnUsers(user, history)}

						<CmpLogoutBtn/>
					</div>
					
					{
						state.videos.length?
						<div className = "row">
							<div className = {hasSidebar ? "col-12 col-lg-8" : "col-12"}>
								<div className = "player-slot" ref = {playerSlot}>
									<div className = {`player-float ${floating ? "floating" : ""}`}>
										{
											floating?
											<div className = "mini-bar">
												<span className = "mini-title" title = {currVideo?.title}>{currVideo?.title}</span>
												<button onClick = {scrollToPlayer} title = "Torna al video">
													<FontAwesomeIcon icon = "arrow-up"/>
												</button>
												<button onClick = {() => setMiniClosed(true)} title = "Chiudi mini player">
													<FontAwesomeIcon icon = "times"/>
												</button>
											</div> : null
										}
										<CmpVideoPlayer user = {user}/>
									</div>
								</div>
								<CmpVideoInfo onLinkClick={handleVideoLinkClick}/>
							</div>
							{
								hasSidebar?
								<div className = "col-12 col-lg-4 video-sidebar">
									<CmpVideoList videoList = {state.videos} layout = "sidebar"/>
								</div> : null
							}
						</div> : null
					}
				</div>
			</div>
        </div>
    );
}

const escapeAttr = str => String(str)
	.replace(/&/g, "&amp;")
	.replace(/"/g, "&quot;")
	.replace(/</g, "&lt;")
	.replace(/>/g, "&gt;");

const renderTitleDangerously = (html) => {
    return <h1 className = "title mr-auto" dangerouslySetInnerHTML = {{__html: html}}/>
};

const renderBtnUsers = (user, history) =>
	user.isAdmin?
		<>
		<button className = "users-btn mr-3" onClick = {() => history.push("/users")} title = "Log utenti">
		Log utenti
		<FontAwesomeIcon icon = "users-cog" className = "ml-2"/>
		</button> 
		<button className = "xml-btn mr-3" onClick = {() => history.push("/edit")} title = "Edit xml">
		Edit xml
		<FontAwesomeIcon icon = "edit" className = "ml-2"/>
		</button> 
		</>

	:
	null;

export default PgVideos;